module.exports = __webpack_public_path__ + "static/img/KR.73a169e6.png";